<template>
  <BLayout
    v-if="selectedCallTargetIds.length > 0"
    align-center
    justify-center
    class="lead-bulk-actions-footer"
  >
    <div class="mr-300">
      {{ $t('general.bulk.selected') }}<span class="fs-500 fw-bold mr-100 ml-100">{{ selectedCallTargetIds.length }}</span>{{ $t('general.bulk.numberOf') }}
    </div>
    <BSelect
      v-model="selectedItemId"
      class="mr-400 bulk-item-select"
      :items="ITEMS"
      item-text="name"
      item-value="id"
      :placeholder="$t('general.select.of', { item: $t('general.item') })"
      filterable
    />
    <BBtn
      type="primary"
      :disabled="bulkDisabled"
      @click="handleBulkUpdateClick"
    >
      {{ $t('general.bulk.update') }}
    </BBtn>
  </BLayout>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

type TItemId = 'operator' | 'freeTag' | 'leadSource';

type TProps = {
  selectedCallTargetIds: number[];
};
type TEmit = (event: 'clickBulkUpdate', itemId: TItemId) => void;

const props = defineProps<TProps>();
const emit = defineEmits<TEmit>();
const i18n = useI18n();

const ITEMS: { id: TItemId, name: string }[] = [
  { id: 'operator', name: i18n.t('operatorAssign.assignedOperator') },
  { id: 'freeTag', name: i18n.t('freeTag.title') },
  { id: 'leadSource', name: i18n.t('callTarget.leadSource') },
];

const selectedItemId = ref<TItemId | null>(null);

const bulkDisabled = computed<boolean>(() =>
  !selectedItemId.value || props.selectedCallTargetIds.length === 0,
);

const handleBulkUpdateClick = () => {
  emit('clickBulkUpdate', selectedItemId.value);
};
</script>

<style lang="scss" scoped>
.lead-bulk-actions-footer {
  background-color: $bgcolor-white;
  box-shadow: $boxshadow-footer;
  padding: $basespace-300 0;

  .bulk-item-select {
    width: 165px;
    height: 42px;
  }
}
</style>
